var _metadata, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLightLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "958.000000pt",
    height: "960.000000pt",
    viewBox: "0 0 958.000000 960.000000",
    fill: "#1f2858;",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, "\nCreated by potrace 1.16, written by Peter Selinger 2001-2019\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,960.000000) scale(0.100000,-0.100000)",
    fill: "#1f2858",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3645 6128 c-3 -7 -4 -609 -3 -1338 l3 -1325 292 -3 293 -2 2 427 3 428 230 2 230 2 286 -427 286 -427 342 -3 c187 -1 341 1 341 5 0 5 -125 188 -278 408 -153 220 -509 733 -791 1140 -283 407 -518 746 -524 753 -43 55 76 -68 588 -603 323 -338 593 -615 599 -615 6 0 52 42 102 94 163 166 223 330 224 604 0 92 -6 170 -16 219 -81 392 -376 622 -849 662 -182 16 -1354 14 -1360 -1z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightLogo);
export default __webpack_public_path__ + "static/media/light-logo.223367f9968d34af594b4207cd75676e.svg";
export { ForwardRef as ReactComponent };